// src/hooks/queries/useUserProfile.ts

"use client";

import { useQuery } from "@tanstack/react-query";
import { getUserProfileAction } from "@/resources/actions/auth.actions";
import { queryKeys } from "@/lib/query-keys";

/**
 * User profile query hook
 * Fetches full user profile from /auth/me
 */
export function useUserProfile() {
  return useQuery({
    queryKey: queryKeys.auth.userProfile(),
    queryFn: async () => {
      return await getUserProfileAction();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    // Note: Retry logic is handled globally in Web3Provider
    refetchOnMount: true,
  });
}
